export const chipDataUpdated = [
  { key: "e", label: 'ETFs', tooltip: 'ETFs' },
  { key: "st", label: 'Stocks', tooltip: 'Stocks' },
  { key: "sw", label: 'Sweeps', tooltip: 'Trades executed rapidly across multiple exchanges' },
  { key: "c", label: 'Calls', tooltip: 'Call options' },
  { key: "pu", label: 'Puts', tooltip: 'Put options' },
  { key: "b", label: 'Bid', tooltip: 'Trades executed on the bid side' },
  { key: "a", label: 'Ask', tooltip: 'Trades executed on the ask side' },
  { key: "AA", label: 'AA', tooltip: 'Above Ask. They really wanted these contracts!' }, //
  { key: "u", label: 'Unusual', tooltip: 'Trade size exceeding open interest' }, { key: "hp3", label: 'Urgent', tooltip: 'Rapid repeat trades matching Bullflow criteria' },
  { key: "hp", label: 'Bullflow', tooltip: 'Aggressive repeat trades matching Bullflow criteria.' },
  { key: "hp45", label: 'Position Builders', tooltip: 'Consistent repeat trades matching Bullflow criteria' },
  { key: "sz", label: 'Sizable', tooltip: 'Large Unusual Trades' },
  { key: "gr", label: 'Grenade', tooltip: 'Risky short term trades' },
  { key: "100k+", label: '100k+', tooltip: 'Trades with $100,000+ value' },
  { key: "w", label: 'Whales', tooltip: '$1M+' },
  { key: "rs", label: 'Rising', tooltip: 'Trades with contract volume that just surpassed the OI' },
  { key: "am", label: 'AM Spike', tooltip: 'Volume exceeding 15% of the OI, 25k OI minimum, before 11am EST' },
  { key: "l", label: 'LEAPS', tooltip: 'Long dated expirations' }, //
  { key: "h", label: 'High Sig', tooltip: 'SigScore 0.8+' },
  { key: "re", label: 'Repeat Flow', tooltip: 'Contracts that have 3 or more size>OI trades.' },
  { key: "ls", label: 'Large Size', tooltip: 'Size > 5000' },
  { key: "es", label: 'Earnings Soon', tooltip: 'Earnings within 2 days' },
  { key: "vo", label: 'Vol>OI', tooltip: 'Volume greater than open interest' },
  { key: "we", label: 'Weeklies', tooltip: 'Trades expiring within a week' },
  { key: "ps", label: 'Penny Stocks', tooltip: 'Stock price < $5' },
  { key: "od", label: 'Oddities', tooltip: 'Stocks not seen on Bullflow in a day' },
  { key: "un", label: 'Unicorns', tooltip: 'Stocks not seen on Bullflow in a week or longer' },
  { key: "o", label: 'OTM', tooltip: 'Out of the money' },
  { key: "bf", label: 'Bullish Flow', tooltip: 'Stocks with 80%+ bullish/bearish ratio' },
];